import { Card, Text, TextAlignment, TokenTextAppearance } from '@volkswagen-onehub/components-core';
import { CheckmarkCircleFilled, ContactDealer } from '@volkswagen-onehub/icons-core';
import { NdpsDealer } from '@esportal/portal-service';

import React from 'react';

interface Props {
	dealer: NdpsDealer;
	isActive?: boolean;
	hasError?: boolean;
	onSelect?: () => void;
}

export function DealerOptionCard(props: Props) {
	const { dealer, isActive = false, hasError = false, onSelect } = props;

	return (
		<Card
			style={{
				height: '100%',
				width: '100%',
			}}
			type={'selectable'}
			isActive={isActive}
			onToggle={() => onSelect?.()}
			{...(hasError &&
				({
					style: {
						outline: '2px solid ' + '#e4002c',
						outlineOffset: '-2px',
						height: '100%',
						width: '100%',
					},
				} as any))}
		>
			<div style={{ display: 'flex', cursor: 'pointer' }}>
				<div style={{ width: '40px' }}>
					{isActive ? (
						<div style={{ color: '#0040C5' }}>
							<CheckmarkCircleFilled />
						</div>
					) : (
						<ContactDealer />
					)}
				</div>
				<div style={{ width: 'calc(100% - 40px)' }}>
					<div
						style={{
							display: 'flex',
							flexDirection: 'row',
							marginBottom: '5px',
						}}
					>
						<Text bold appearance={TokenTextAppearance.headline100}>
							{dealer.VGED_CommercialName__c}
						</Text>
						<div
							style={{
								minWidth: '70px',
								marginLeft: 'auto',
							}}
						>
							<Text bold appearance={TokenTextAppearance.headline100} textAlign={TextAlignment.right}>
								{dealer.Distance ? `${dealer.Distance.toFixed(1)} km` : ''}
							</Text>
						</div>
					</div>
					<Text appearance={TokenTextAppearance.copy100}>
						{dealer.ShippingStreet}, {dealer.ShippingPostalCode} {dealer.ShippingCity}
					</Text>
				</div>
			</div>
		</Card>
	);
}
